import asanaIcon from "../assets/images/asana_icon.png";
import linkIcon from "../assets/images/link_icon.png";
import chatIcon from "../assets/images/chat.png";
import voiceIcon from "../assets/images/voice.png";
import slackIcon from "../assets/images/slack.png";
import openaiIcon from "../assets/images/chatgpt_icon.png";
import trelloIcon from "../assets/images/trello.png";
import todoistIcon from "../assets/images/todoist.png";
import customPlatformIcon from "../assets/images/customPlatform.png";
import gmailIcon from "../assets/images/gmail.png";
import outlookIcon from "../assets/images/outlook.png";
import google_calendarIcon from "../assets/images/google_calender.png";
import outlook_calendarIcon from "../assets/images/outlook_calender.png";
import microsoft_todoIcon from "../assets/images/microsoft_todoIcon.png";
import fathomIcon from "../assets/images/fathom.png";
import githubIcon from "../assets/images/github_icon.png";
import granolaIcon from "../assets/images/granola.png";
import fellowaiIcon from "../assets/images/fellow.ai.png";
import readaiIcon from "../assets/images/read.ai.png";
import firefliesIcon from "../assets/images/fireflies.png";
import meetilyaiIcon from "../assets/images/meetily.png";
import meetgeekIcon from "../assets/images/meetgeek.png";
import tldvIcon from "../assets/images/tldv.png";
import discordIcon from "../assets/images/discord.png";
import notionIcon from "../assets/images/notion.png";
import jiraIcon from "../assets/images/jira.png";
import linearIcon from "../assets/images/linear.png";
import clickupIcon from "../assets/images/clickup.png";
import whatsappIcon from "../assets/images/whatsapp.png";
import instagramIcon from "../assets/images/instagram.png";
import teamsIcon from "../assets/images/microsoft_teams.png";
import messengerIcon from "../assets/images/messenger.png";
import facebookIcon from "../assets/images/facebook.png";
import pipedriveIcon from "../assets/images/pipedrive.jpeg";
import twilioIcon from "../assets/images/twilio.png";
import crispIcon from "../assets/images/crisp.jpeg";
import intercomIcon from "../assets/images/intercom.png";

export const SIDEBAR_LINKS_PLATFORM = [
  // {
  //   to: "/installed-assistant",
  //   label: "Installed Assistant",
  //   icon: "appSettings",
  // },
  { to: "/meetings", label: "Meetings", icon: "meetings" },
  { to: "/tasks", label: "Tasks", icon: "sidebar" },
  { to: "/conversations", label: "Conversations", icon: "chat" },
  { to: "/integrations", label: "Integrations", icon: "integration" },
  // { to: "/agents", label: "Agents", icon: "voice" },
  { to: "/apps", label: "Apps", icon: "Collection" },
  { to: "/participants", label: "Participants", icon: "people" },
  { to: "/billing", label: "Billing", icon: "billing" },

  // { to: "/users", label: "Users", icon: "user" },
  // {
  //   to: "/my-assistants",
  //   label: "My Assistants",
  //   icon: "system-activity",
  // },
  // { to: "/platform", label: "Platforms", icon: "platform" },
  // { to: "/phone-numbers", label: "Phone Numbers", icon: "call" },
];

export const SIDEBAR_LINKS_SUPERADMIN = [
  { to: "/admin/users", label: "Users", icon: "people" },
  { to: "/admin/agents", label: "Agents", icon: "voice" },
  { to: "/admin/meetings", label: "Meetings", icon: "meetings" },
  { to: "/admin/apps", label: "App Installed", icon: "Collection" },
  { to: "/admin/integrations", label: "Integrations", icon: "integration" },
  { to: "/admin/participants", label: "Participants", icon: "people" },
  { to: "/admin/activities", label: "Activities", icon: "appSettings" },
  { to: "/admin/payments", label: "Payments", icon: "billing" },
];

export const SIDEBAR_LINKS_CONSUMERS = [
  { to: "/dashboard", label: "Dashboard", icon: "appSettings" },
  { to: "/assistants", label: "Assistants", icon: "user" },
  { to: "/billing", label: "Billing", icon: "billing" },
];

export const FILE_TYPE_ICONS = {
  pdf: { icon: "file-text", label: "PDF" },
  txt: { icon: "file-text", label: "Text" },
  md: { icon: "file-text", label: "Text" },
  jpg: { icon: "image", label: "Image" },
  jpeg: { icon: "image", label: "Image" },
  png: { icon: "image", label: "Image" },
  gif: { icon: "image", label: "Image" },
  bmp: { icon: "image", label: "Image" },
  webp: { icon: "image", label: "Image" },
  mp4: { icon: "video", label: "Video" },
  avi: { icon: "video", label: "Video" },
  mov: { icon: "video", label: "Video" },
  mkv: { icon: "video", label: "Video" },
  webm: { icon: "video", label: "Video" },
};

export const WIDGET_ICONS = {
  link: linkIcon,
};

export const ICONS = {
  ASANA: asanaIcon,
  SLACK: slackIcon,
  TRELLO: trelloIcon,
  TODOIST: todoistIcon,
  GMAIL: gmailIcon,
  OUTLOOK: outlookIcon,
  GOOGLE_CALENDAR: google_calendarIcon,
  OUTLOOK_CALENDAR: outlook_calendarIcon,
  MICROSOFT_TODO: microsoft_todoIcon,
  GITHUB: githubIcon,
  OTHER: customPlatformIcon,
  FATHOM: fathomIcon,
  GRANOLA: granolaIcon,
  FELLOW_AI: fellowaiIcon,
  READ_AI: readaiIcon,
  FIREFLIES: firefliesIcon,
  MEETILYAI: meetilyaiIcon,
  MEETGEEK: meetgeekIcon,
  TLDV: tldvIcon,
  NOTION: notionIcon,
  DISCORD: discordIcon,
  JIRA: jiraIcon,
  LINEAR: linearIcon,
  CLICKUP: clickupIcon,
  WHATSAPP: whatsappIcon,
  INSTAGRAM: instagramIcon,
  TEAMS: teamsIcon,
  MESSENGER: messengerIcon,
  FACEBOOK: facebookIcon,
  PIPEDRIVE: pipedriveIcon,
  TWILIO: twilioIcon,
  CRISP: crispIcon,
  INTERCOM: intercomIcon,
};

export const MODEL_ICONS = {
  chat: chatIcon,
  voice: voiceIcon,
  openai: openaiIcon,
};

export const TOOL_ICONS = {
  ASANA: asanaIcon,
};

export const ROLE = {
  ADMIN: "ADMIN",
  USER: "USER",
};

export const PLATFORMS = {
  ASANA: "asana",
  SLACK: "slack",
  TRELLO: "trello",
  TODOIST: "todoist",
  GMAIL: "gmail",
  OUTLOOK: "outlook",
  GOOGLE_CALENDAR: "google_calendar",
  OUTLOOK_CALENDAR: "outlook_calendar",
  MICROSOFT_TODO: "microsoft_todo",
  YOUTUBE: "youtube",
  OTHER: "other",
  NONE: "none",
  GITHUB: "github",
  NOTION: "notion",
  JIRA: "jira",
  LINEAR: "linear",
  CLICKUP: "clickup",
  PIPEDRIVE: "pipedrive",

  GOOGLE_SHEETS: "google_sheets",
  SUPABASE: "supabase",
  PERPLEXITY_AI: "perplexity_ai",
  TWITTER: "twitter",
  GOOGLE_DRIVE: "google_drive",
  GOOGLE_DOCS: "google_docs",
  HUBSPOT: "hubspot",
  AIRTABLE: "airtable",
  FIRECRAWL: "firecrawl",
  BITBUCKET: "bitbucket",
  GOOGLE_TASKS: "google_tasks",
  DISCORD: "discord",
  REDDIT: "reddit",
  CAL: "cal",
  SENTRY: "sentry",
  SNOWFLAKE: "snowflake",
  HACKER_NEWS: "hacker_news",
  MICROSOFT_TEAMS: "microsoft_teams",
  SHOPIFY: "shopify",
  LINKEDIN: "linkedin",
  ONEDRIVE: "onedrive",
  DOCUSIGN: "docusign",
  SALESFORCE: "salesforce",
  CALENDLY: "calendly",
  APOLLO: "apollo",
  SEMRUSH: "semrush",
  NEON: "neon",
  OPENWEATHERMAP: "openweathermap",
  POSTHOG: "posthog",
  BREVO: "brevo",
  STRIPE: "stripe",
  KLAVIYO: "klaviyo",
  MAILCHIMP: "mailchimp",
  GOOGLE_MEET: "google_meet",
  TEXT_TO_PDF: "text_to_pdf",
  ZOHO: "zoho",
  FIREFLIES: "fireflies",
  DROPBOX: "dropbox",
  CONFLUENCE: "confluence",
  FRESHDESK: "freshdesk",
  MIXPANEL: "mixpanel",
  CODA: "coda",
  AFFINITY: "affinity",
  AMPLITUDE: "amplitude",
  GOOGLE_BIGQUERY: "google_bigquery",
  MONDAY: "monday",
  BAMBOOHR: "bamboohr",
  WHATSAPP: "whatsapp",
  DYNAMICS_365: "dynamics_365",
  ZENDESK: "zendesk",
  GOOGLE_PHOTOS: "google_photos",
  META_ADS: "meta_ads",
  LISTEN_NOTES: "listen_notes",
  ZOOM: "zoom",
  SERVICENOW: "servicenow",
  GOOGLE_ADS: "google_ads",
  MIRO: "miro",
  CONTENTFUL: "contentful",
  NETSUITE: "netsuite",
  SURVEYMONKEY: "surveymonkey",
  ZOHO_BOOKS: "zoho_books",
  ZOHO_INVENTORY: "zoho_inventory",
  FACEBOOK: "facebook",
  CANVA: "canva",
  BOX: "box",
  FRESHBOOKS: "freshbooks",
  PANDADOC: "pandadoc",
  ZOHO_DESK: "zoho_desk",
  BASEROW: "baserow",
  TINYURL: "tinyurl",
  GUMROAD: "gumroad",
  FOURSQUARE: "foursquare",
  OPENSEA: "opensea",
  CLOUDFLARE: "cloudflare",
  XERO: "xero",
  ZOHO_MAIL: "zoho_mail",
  INTERCOM: "intercom",
  EVENTBRITE: "eventbrite",
  WORKDAY: "workday",
  ZOHO_INVOICE: "zoho_invoice",
  STACK_EXCHANGE: "stack_exchange",
  DATADOG: "datadog",
  BASECAMP: "basecamp",
  ALGOLIA: "algolia",
  APIFY: "apify",
  GITLAB: "gitlab",
  JOTFORM: "jotform",
  MAKE: "make",
  PIPELINE_CRM: "pipeline_crm",
  NOTION_MCP: "notion_mcp",
  NOCODB: "nocodb",
  OPENAI: "openai",
  PAPERFORM: "paperform",
  QUICKBOOKS: "quickbooks",
  SCRAPINGBEE: "scrapingbee",
  TICKTICK: "ticktick",
  TIKTOK: "tiktok",
  TOGGL: "toggl",
  TYPEFORM: "typeform",
  SALESFORCE_SERVICE_CLOUD: "salesforce_service_cloud",
};

export const getIcon = (platformName) => {
  const name = (platformName || "").toLowerCase().replace(/\s+/g, "_");

  switch (name) {
    case PLATFORMS.ASANA:
      return ICONS.ASANA;

    case PLATFORMS.SLACK:
      return ICONS.SLACK;

    case PLATFORMS.TRELLO:
      return ICONS.TRELLO;

    case PLATFORMS.TODOIST:
      return ICONS.TODOIST;

    case PLATFORMS.GMAIL:
      return ICONS.GMAIL;

    case PLATFORMS.OUTLOOK:
      return ICONS.OUTLOOK;

    case PLATFORMS.GOOGLE_CALENDAR:
      return ICONS.GOOGLE_CALENDAR;

    case PLATFORMS.OUTLOOK_CALENDAR:
      return ICONS.OUTLOOK_CALENDAR;

    case PLATFORMS.MICROSOFT_TODO:
      return ICONS.MICROSOFT_TODO;

    case PLATFORMS.GITHUB:
      return ICONS.GITHUB;

    case INTEGRATION_ENUM.FATHOM:
      return ICONS.FATHOM;

    case INTEGRATION_ENUM.GRANOLA:
      return ICONS.GRANOLA;

    case INTEGRATION_ENUM.FELLOW_AI:
      return ICONS.FELLOW_AI;

    case INTEGRATION_ENUM.READ_AI:
      return ICONS.READ_AI;

    case INTEGRATION_ENUM.FIREFLIES:
      return ICONS.FIREFLIES;

    case INTEGRATION_ENUM.MEETILYAI:
      return ICONS.MEETILYAI;

    case INTEGRATION_ENUM.MEETGEEK:
      return ICONS.MEETGEEK;

    case INTEGRATION_ENUM.TLDV:
      return ICONS.TLDV;

    case PLATFORMS.NOTION:
      return ICONS.NOTION;

    case PLATFORMS.LINEAR:
      return ICONS.LINEAR;

    case INTEGRATION_ENUM.DISCORD:
      return ICONS.DISCORD;

    case PLATFORMS.JIRA:
      return ICONS.JIRA;

    case PLATFORMS.CLICKUP:
      return ICONS.CLICKUP;

    case INTEGRATION_ENUM.WHATSAPP:
      return ICONS.WHATSAPP;

    case INTEGRATION_ENUM.INSTAGRAM_MESSAGES:
    case INTEGRATION_ENUM.INSTAGRAM_READONLY_MESSAGES:
      return ICONS.INSTAGRAM;

    case INTEGRATION_ENUM.FACEBOOK_MESSAGES:
    case INTEGRATION_ENUM.FACEBOOK_READONLY_MESSAGES:
      return ICONS.MESSENGER;

    case INTEGRATION_ENUM.INSTAGRAM_COMMENTS:
      return ICONS.INSTAGRAM;

    case INTEGRATION_ENUM.FACEBOOK_COMMENTS:
      return ICONS.FACEBOOK;

    case PLATFORMS.PIPEDRIVE:
      return ICONS.PIPEDRIVE;

    case INTEGRATION_ENUM.CRISP:
      return ICONS.CRISP;

    case PLATFORMS.OTHER:
      return ICONS.OTHER;

    case PLATFORMS.NONE:
      return ICONS.OTHER;

    case INTEGRATION_ENUM.TEAMS:
      return ICONS.TEAMS;

    case INTEGRATION_ENUM.TWILIO:
      return ICONS.TWILIO;

    case INTEGRATION_ENUM.INTERCOM:
      return ICONS.INTERCOM;

    default:
      return ICONS.default;
  }
};

export const ASANA_BASE_URL = "https://app.asana.com/api/1.0";
export const TRELLO_BASE_URL = "https://api.trello.com/1";
export const TODOIST_BASE_URL = "https://api.todoist.com/api/v1";
export const PLATFORMS_ENUM = [
  "asana",
  "slack",
  "trello",
  "todoist",
  "gmail",
  "outlook",
  "google_calendar",
  "outlook_calendar",
  "microsoft_todo",
  "other",
  "none",
  "github",
  "notion",
  "jira",
  "clickup",
  "pipedrive",

  "google_sheets",
  "supabase",
  "perplexity_ai",
  "twitter",
  "google_drive",
  "google_docs",
  "hubspot",
  "linear",
  "airtable",
  "firecrawl",
  "youtube",
  "bitbucket",
  "google_tasks",
  "discord",
  "reddit",
  "cal",
  "sentry",
  "snowflake",
  "hacker_news",
  "microsoft_teams",
  "shopify",
  "linkedin",
  "onedrive",
  "docusign",
  "salesforce",
  "calendly",
  "apollo",
  "semrush",
  "neon",
  "openweathermap",
  "posthog",
  "brevo",
  "stripe",
  "klaviyo",
  "mailchimp",
  "google_meet",
  "text_to_pdf",
  "zoho",
  "fireflies",
  "dropbox",
  "confluence",
  "freshdesk",
  "mixpanel",
  "coda",
  "affinity",
  "amplitude",
  "google_bigquery",
  "monday",
  "bamboohr",
  "whatsapp",
  "dynamics_365",
  "zendesk",
  "google_photos",
  "meta_ads",
  "listen_notes",
  "zoom",
  "servicenow",
  "google_ads",
  "miro",
  "contentful",
  "netsuite",
  "surveymonkey",
  "zoho_books",
  "zoho_inventory",
  "facebook",
  "canva",
  "box",
  "freshbooks",
  "pandadoc",
  "zoho_desk",
  "baserow",
  "tinyurl",
  "gumroad",
  "foursquare",
  "opensea",
  "cloudflare",
  "xero",
  "zoho_mail",
  "intercom",
  "eventbrite",
  "workday",
  "zoho_invoice",
  "stack_exchange",
  "datadog",
  "basecamp",
  "algolia",
  "apify",
  "gitlab",
  "jotform",
  "make",
  "pipeline_crm",
  "notion_mcp",
  "nocodb",
  "openai",
  "paperform",
  "quickbooks",
  "scrapingbee",
  "ticktick",
  "tiktok",
  "toggl",
  "typeform",
  "salesforce_service_cloud",
];

export const capitalize = (str = "") =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const getEditableIntegrationName = (value = "") =>
  String(value)
    .replace(/_+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const toIntegrationNameKey = (value = "") =>
  getEditableIntegrationName(value).replace(/\s/g, "_");

export const formatIntegrationName = (value = "") => {
  const format = (str = "") => {
    const specialCases = {
      facebook_messages: "Facebook Messages (Read+Write)",
      instagram_messages: "Instagram Messages (Read+Write)",
      facebook_readonly_messages: "Facebook Messages (Read Only)",
      instagram_readonly_messages: "Instagram Messages (Read Only)",
    };

    if (specialCases[str.toLowerCase()]) {
      return specialCases[str.toLowerCase()];
    }

    return (str || "")
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (!value || (Array.isArray(value) && value.length === 0)) {
    return "-";
  }

  if (Array.isArray(value)) {
    return value.map(format).join(", ");
  }

  return format(value) || "-";
};

export const formatPlatformName = (value = "") => {
  const format = (str = "") =>
    (str || "")
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  if (!value || (Array.isArray(value) && value.length === 0)) {
    return "-";
  }

  if (Array.isArray(value)) {
    return value.map(format).join(", ");
  }

  return format(value) || "-";
};

export const AVAILABLE_PRICING = [
  {
    id: "price_5",
    amount: 5,
    label: "$5 Plan",
  },
  {
    id: "price_10",
    amount: 10,
    label: "$10 Plan",
  },
  {
    id: "price_25",
    amount: 25,
    label: "$25 Plan",
  },
  {
    id: "price_50",
    amount: 50,
    label: "$50 Plan",
  },
  {
    id: "price_100",
    amount: 100,
    label: "$100 Plan",
  },
];

export const AVAILABLE_PLATFORMS = [
  "asana",
  "slack",
  "trello",
  "todoist",
  "gmail",
  "outlook",
  "google_calendar",
  "outlook_calendar",
  "microsoft_todo",
  "github",
  "notion",
  "jira",
  "linear",
  "clickup",
  "pipedrive",
];

export const SUBSCRIPTION_PLANS = {
  TRIAL: "Trial Plan",
  SUBSCRIPTION_1: "Personal Plan",
  SUBSCRIPTION_2: "Business Plan",
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: "Active",
  OVERDUE: "Overdue",
  CANCELLED: "Cancelled",
  EXPIRED: "Expired",
  MANUALLY_CANCELLED: "Cancelled",
};

export const DURATION_OPTIONS = [
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1 hour", value: 60 },
  { label: "1.5 hours", value: 90 },
  { label: "2 hours", value: 120 },
  { label: "2.5 hours", value: 150 },
  { label: "3 hours", value: 180 },
  { label: "4 hours", value: 240 },
];

export const AVATAR_COLORS = [
  "#2966ce",
  "#c03a45",
  "#34919d",
  "#6a9b47",
  "#a47f3a",
  "#834d94",
];

export const INTEGRATIONS = [
  "fathom",
  "granola",
  "slack",
  "discord",
  "whatsapp",
  "instagram_messages",
  "facebook_messages",
  "instagram_comments",
  "facebook_comments",
  "fellow.ai",
  "read.ai",
  "fireflies",
  "meetily.ai",
  "meetgeek",
  "tldv",
  "crisp",
  "intercom",
];

export const INTEGRATION_ENUM = {
  FATHOM: "fathom",
  GRANOLA: "granola",
  DISCORD: "discord",
  WHATSAPP: "whatsapp",
  FELLOW_AI: "fellow.ai",
  READ_AI: "read_ai",
  FIREFLIES: "fireflies",
  MEETILYAI: "meetily.ai",
  MEETGEEK: "meetgeek",
  TLDV: "tldv",
  SLACK: "slack",
  GMAIL: "gmail",
  OUTLOOK: "outlook",
  INSTAGRAM_MESSAGES: "instagram_messages",
  TEAMS: "teams",
  FACEBOOK_MESSAGES: "facebook_messages",
  INSTAGRAM_COMMENTS: "instagram_comments",
  FACEBOOK_READONLY_MESSAGES: "facebook_readonly_messages",
  INSTAGRAM_READONLY_MESSAGES: "instagram_readonly_messages",
  FACEBOOK_COMMENTS: "facebook_comments",
  TWILIO: "twilio",
  CRISP: "crisp",
  INTERCOM: "intercom",
};

export const CATEGORY_TITLES = {
  TASKS: "Task Management",
  EMAIL_CALENDAR: "Email & Calendar",
  COMMUNICATION: "Communication",
};

export const PLATFORM_DISPLAY_NAMES = {
  github: "GitHub Tasks",
};

export const CONFIGURABLE_INTEGRATIONS = [
  "slack",
  "discord",
  "whatsapp",
  "teams",
  "twilio",
  "facebook_messages",
  "facebook_comments",
  "facebook_readonly_messages",
  "instagram_messages",
  "instagram_comments",
  "instagram_readonly_messages",
];



export const getMenuItems = (navigate) => [
  {
    label: "Profile",
    icon: "user",
    onClick: () => navigate("/profile"),
  },
  {
    label: "Integrations",
    icon: "integration",
    onClick: () => navigate("/integrations"),
  },
  {
    label: "Apps",
    icon: "Collection",
    onClick: () => navigate("/apps"),
  },
  {
    label: "Team Members",
    icon: "people",
    onClick: () => navigate("/team-members"),
  },
  {
    label: "Billing",
    icon: "billing",
    onClick: () => navigate("/billing"),
  },
];

export const CATEGORY_TABS = [
  {
    key: "complaint",
    label: "Complaint",
    icon: "webconnect-exclamation-triangle-fill",
  },
  { key: "lead", label: "Lead", icon: "webconnect-person-plus-fill" },
  { key: "query", label: "Query", icon: "webconnect-question-circle" },
  { key: "noise", label: "Noise", icon: "webconnect-volume-up" },
];

export const MESSAGE_GROUPED_PLATFORMS = [
  INTEGRATION_ENUM.INSTAGRAM_MESSAGES,
  INTEGRATION_ENUM.FACEBOOK_MESSAGES,
];

export const TASK_CATEGORY = {
  COMPLAINT: "complaint",
  LEAD: "lead",
  QUERY: "query",
  NOISE: "noise",
};

export const CATEGORY_CONFIG = [
  {
    key: TASK_CATEGORY.COMPLAINT,
    label: "Complaint",
    pluralLabel: "Complaints",
    icon: "bi-exclamation-triangle-fill",
    color: "#dc3545",
    borderClass: "border-danger-subtle",
    badgeClass: "bg-danger-subtle text-danger border border-danger-subtle",
    headerBg: "rgba(220, 53, 69, 0.05)",
  },
  {
    key: TASK_CATEGORY.LEAD,
    label: "Lead",
    pluralLabel: "Leads",
    icon: "bi-person-plus-fill",
    color: "#198754",
    borderClass: "border-success-subtle",
    badgeClass: "bg-success-subtle text-success border border-success-subtle",
    headerBg: "rgba(25, 135, 84, 0.05)",
  },
  {
    key: TASK_CATEGORY.QUERY,
    label: "Query",
    pluralLabel: "Queries",
    icon: "bi-question-circle-fill",
    color: "#0d6efd",
    borderClass: "border-primary-subtle",
    badgeClass: "bg-primary-subtle text-primary border border-primary-subtle",
    headerBg: "rgba(13, 110, 253, 0.05)",
  },
  {
    key: TASK_CATEGORY.NOISE,
    label: "Noise",
    pluralLabel: "Noise",
    icon: "bi-volume-up-fill",
    color: "#6c757d",
    borderClass: "border-secondary-subtle",
    badgeClass:
      "bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle",
    headerBg: "rgba(108, 117, 125, 0.05)",
  }
];

export const STATUS_BADGE = {
  COMPLETED: { cls: "bg-success-subtle text-success", label: "Completed" },
  PROCESSING_TASKS: {
    cls: "bg-warning-subtle text-warning",
    label: "Processing",
  },
  COMPLETED_NO_TASK: {
    cls: "bg-secondary-subtle text-secondary-emphasis",
    label: "No Relevant Tasks Found",
  },
  PROCESSING: { cls: "bg-info-subtle text-info", label: "Analyzing" },
  PENDING: {
    cls: "bg-secondary-subtle text-secondary-emphasis",
    label: "Pending",
  },
  FAILED: { cls: "bg-danger-subtle text-danger", label: "Failed" },
};


export const  SCRAPPER_PLATFORMS = {
  FACEBOOK :"facebook",
  YOUTUBE :"youtube",
  INSTAGRAM :"instagram",
}
